<div class="flex flex-col gap-3">
  <px-catalog-search-cover-and-details-column [catalogRecord]="catalogRecord"/>
  <px-catalog-search-availability-column [catalogRecord]="catalogRecord"/>
</div>
